import React from "react";
import type { Direction } from "../types.ts";

interface GameControlsProps {
  steps: number;
  totalFuel: number;
  fuelRemaining: number;
  canUndo: boolean;
  phase: string;
  onMoveDir: (dir: Direction) => void;
  onUndo: () => void;
  onReset: () => void;
}

export function GameControls({
  steps, totalFuel, fuelRemaining, canUndo, phase,
  onMoveDir, onUndo, onReset,
}: GameControlsProps) {
  const disabled = phase === "won" || phase === "stuck" || phase === "starting";

  return (
    <div className="flex flex-col items-center gap-4">
      {/* D-pad */}
      <div className="grid grid-cols-3 gap-1 w-36">
        <div />
        <DPadButton dir="up" label={"\u2191"} disabled={disabled} onMove={onMoveDir} />
        <div />
        <DPadButton dir="left" label={"\u2190"} disabled={disabled} onMove={onMoveDir} />
        <div className="w-11 h-11" />
        <DPadButton dir="right" label={"\u2192"} disabled={disabled} onMove={onMoveDir} />
        <div />
        <DPadButton dir="down" label={"\u2193"} disabled={disabled} onMove={onMoveDir} />
        <div />
      </div>

      {/* Actions + counter */}
      <div className="flex items-center gap-4">
        <button
          onClick={onUndo}
          disabled={!canUndo}
          className="px-4 py-2 bg-slate-800 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed rounded-lg text-sm font-medium transition-colors border border-slate-600"
        >
          Undo
        </button>
        <button
          onClick={onReset}
          className="px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-sm font-medium transition-colors border border-slate-600"
        >
          Reset
        </button>
        <div className="text-sm text-slate-400">
          <span className="text-white font-mono">{steps}</span>
          {" steps"}
          <span className="mx-2 text-slate-600">|</span>
          <span className="font-mono text-orange-400">{fuelRemaining}</span>
          {" / "}
          <span className="font-mono">{totalFuel}</span>
          {" fuel"}
        </div>
      </div>
    </div>
  );
}

function DPadButton({
  dir, label, disabled, onMove,
}: {
  dir: Direction;
  label: string;
  disabled: boolean;
  onMove: (dir: Direction) => void;
}) {
  return (
    <button
      onClick={() => onMove(dir)}
      disabled={disabled}
      className="w-11 h-11 flex items-center justify-center bg-slate-800 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed rounded-lg text-lg font-bold transition-colors border border-slate-600 select-none"
    >
      {label}
    </button>
  );
}
